import { ListItem } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { TopSellingProductProps } from "./types";
import useStyles from "./styles";
import { Currency } from "../../../../components/misc/Currency";

export const TopSellingProduct: FunctionComponent<TopSellingProductProps> = (
  product: TopSellingProductProps
) => {
  const classes = useStyles();

  return (
    <ListItem component="div" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <span className={classes.ranking}>{product.ranking}.</span>
      <span className={classes.productName}> {product.productName}</span>
      <span className={classes.priceQty}>
        {" "}
        <Currency value={product.amountSoldTotal} />
      </span>
    </ListItem>
  );
};
